import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useContext,
} from "react";
import { View } from "react-native";
import { navigate } from "../../../helpers/utils";

import EmptyPageIcons from "../common/icons/empty-pages";
import ManaButton from "../common/ManaButton";
import CountDownTimer from "./CountDownTimer";
import appStyles from "../../appStyles";
import ReflectionHeader from "../reflection/header/ReflectionHeader";
import ReflectionFabButton from "../reflection/ReflectionFabButton";
import styles from "./emptyPageStyles";
import appPages from "../../../appPages";
import GenericOverlay from "./GenericOverlay";
import ViewModes from "../reflection/header/viewModes";
import ReflectionContext from "../reflection/ReflectionContext";

const EmptyReflectionPage = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    showMariMessage: (message) => setMessage(message),
  }));

  const {
    userCreatedTime,
    header,
    title,
    controller,
    openOverlay = false,
    closeTutorialOverlay = () => {},
  } = props;

  const context = useContext(ReflectionContext) || {};
  const { viewMode, changeViewMode = () => {} } = context;

  const [showOverlay, setShowOverlay] = useState(openOverlay);
  const [message, setMessage] = useState("");

  const closeOverlay = () => {
    setShowOverlay(false);
    setMessage("");

    // User is for the 1st time on the page and closes the tutorial
    if (openOverlay) {
      closeTutorialOverlay();
    }
  };

  const goToMappingGamePage = () => {
    navigate(controller, appPages.integrationsMappingGame);
  };

  const customizeElements = () => {
    navigate(controller, appPages.customizeElementsPage);
  };

  return (
    <View style={[appStyles.container]}>
      {/* Header */}
      <ReflectionHeader header={header} title={title} controller={controller} />

      {/* Overlay */}
      {showOverlay ? (
        <GenericOverlay
          ImageTag={
            viewMode == ViewModes.chartView
              ? EmptyPageIcons.ReflectionSparkOverlay
              : EmptyPageIcons.ReflectionOverlay
          }
          onButtonPress={closeOverlay}
        />
      ) : null}

      <View style={[styles.container]}>
        <View style={styles.imageContainer}>
          <EmptyPageIcons.Reflection />
        </View>

        <CountDownTimer
          title="Your custom insights will be ready in"
          time={userCreatedTime}
          onDone={() => setShowOverlay(true)}
        />

        <ManaButton
          isMainButton
          text="Help us understand your time"
          style={styles.button}
          styleText={styles.buttonText}
          onPress={goToMappingGamePage}
        />

        <ManaButton
          text="Preview Reflection (limited insights)"
          style={styles.button}
          styleText={styles.buttonText}
          onPress={() => changeViewMode(null)}
        />

        <ManaButton
          isLinkButton
          text="Customize Elements"
          style={styles.button}
          styleText={styles.buttonText}
          onPress={customizeElements}
        />
      </View>

      {showOverlay ? null : (
        <ReflectionFabButton
          style={[appStyles.fab, { bottom: 76 }]}
          aboutThisScreen={() => setShowOverlay(true)}
          viewMode={viewMode}
          changeViewMode={changeViewMode}
          mariOptions={
            message
              ? {
                  mariMessage: {
                    message,
                    isFromEmptyState: !!message,
                  },
                }
              : null
          }
        />
      )}
    </View>
  );
});

export default EmptyReflectionPage;
